import React, { useState } from 'react';
import { Icon } from '@iyunbao/components';
import { action } from '@iyunbao/cr-engine';

import PopupBottom from '../../../popupBottom';
import { isObject, isInApp } from '../../../utils/tools';
import { ActionProps } from '../../../utils/type';
import {
  dataBindMaps,
  addressBookSelectData,
  requestPlainText,
} from '../_util';
import ImportCustomers from './importCustomers';
import ImageOCR from './imageOCR';

export type AddressBookProps = boolean | Array<{
  label: string;
  desc: string;
  icon: string;
  action: ActionProps;
}>

export interface UserAddressBookProps {
  prefixCls?: string;
  dataSource?: AddressBookProps;
  path?: string;
  onChange?: (item: any) => void;
  onLog?: (name: string) => void;
}

export interface AddressBookSelectProps {
  prefixCls?: string;
  visible: boolean;
  dataSource?: AddressBookProps;
  path?: string;
  onClose?: () => void;
  onChange?: (item: any) => void;
  onLog?: (name: string) => void;
}
/**
 * 导入选择
 * @param props
 */
function AddressBookSelect(props: AddressBookSelectProps) {
  const {
    prefixCls = 'crm-address-book-select',
    visible,
    path,
    dataSource,
    onClose,
    onLog,
    onChange,
  } = props;
  const [visibleImport, setVisibleImport] = useState(false);
  const [visibleImage, setVisibleImage] = useState(false);

  // 点击客户列表
  function onChangeCsutomers(item: any) {
    // key 对应关系
    if (isObject(item)) {
      let iKey = '';
      Object.keys(item).forEach((key) => {
        iKey = dataBindMaps[key] || key;
        item[iKey] = item[key];
      });
    }

    // 用于埋点标记，回调
    onLog && onLog('importAddressBook');

    requestPlainText(item)
      .then((vItem) => {
        onChange && onChange(vItem);
      });

    setVisibleImport(false);
  }

  // 选择列表
  function onChangeSelect(item) {
    const { log, action: waction } = item || {};

    // 用于埋点标记，回调
    if (log && onLog) {
      onLog && onLog('openAddressBook');
    }

    if (waction && waction.type) {
      const { type, data } = waction || {};

      switch (type) {
        // 打开客户导入
        case 'openAddressBook':
          setVisibleImport(true);
          break;
        // 图片OCR识别
        case 'imageOCR':
          setVisibleImage(true);
          break;
        case 'url':
        case 'urlParam':
          // 投保页面计划书快速导入
          if (path && data && data.url) {
            const addParams = [
              `storeKey=${path}`,
              `back=${encodeURIComponent(window.location.href)}`,
            ];

            data.url += /\?/.test(data.url) ? '&' : '?';
            data.url += addParams.join('&');
          }

          if (action && action[type]) {
            action[type](data);
          }
          break;
        default:
          if (action && action[type]) {
            action[type](data);
          }
          break;
      }
    }
  }

  let options: any = addressBookSelectData;

  if (dataSource && Array.isArray(dataSource) && dataSource.length) {
    options = dataSource.concat(options);
  }

  return (
    <PopupBottom
      visible={visible}
      title="快速录入"
      className={prefixCls}
      onClose={() => onClose && onClose()}
    >
      {
        (options && Array.isArray(options) && options.length) ? options.map((item, key) => {
          if (typeof item.isApp !== 'undefined' && item.isApp !== isInApp) {
            return null;
          }

          return (
            <div
              className={`${prefixCls}-item`}
              key={`${item.key || key}`}
              onClick={() => onChangeSelect(item)}
            >
              <div className="item-label">
                {item.icon ? <Icon type={item.icon} /> : null}
                {item.label}
              </div>
              <div className="item-desc">
                {item.desc}
              </div>
            </div>
          );
        }) : null
      }

      {visibleImport && (
        <ImportCustomers
          visible={visibleImport}
          onLog={onLog}
          onClose={() => setVisibleImport(false)}
          onChange={(item) => onChangeCsutomers(item)}
        />
      )}

      {
        visibleImage && (
          <ImageOCR
            visible={visibleImage}
            onClose={() => setVisibleImage(false)}
            onChange={(item) => {
              onChange && onChange(item);
              setVisibleImage(false);
            }}
          />
        )
      }
    </PopupBottom>
  );
}

// 用户通讯录
function UserAddressBook(props: UserAddressBookProps) {
  const {
    prefixCls = 'crm-input',
    dataSource,
    path,
    onLog,
    onChange,
  } = props;
  const [visible, setVisible] = useState(false);

  // 打开通讯录
  function onOpen() {
    // 用于埋点标记，回调
    onLog && onLog('openFastEntry');

    setVisible(true);
  }

  function onChangeValue(value) {
    setVisible(false);

    onChange && onChange(value);
  }

  return (
    <div className={`${prefixCls}-addressBook`}>
      <div
        className="button-addressBook"
        onClick={() => onOpen()}
        data-attr="button"
      >
        快速录入
      </div>
      <AddressBookSelect
        visible={visible}
        path={path}
        dataSource={dataSource}
        onClose={() => setVisible(false)}
        onLog={onLog}
        onChange={onChangeValue}
      />
    </div>
  );
}

export default UserAddressBook;
